import React, {Component} from 'react';


class ProgressBar extends Component {


    render() {

        let width = this.props.width ? this.props.width : 100;
        let percentage = this.props.percentage ? this.props.percentage : 0;
        // let percentage = 98;
        let done = Math.round(width * percentage / 100);
        if (done < 0) done = 0;
        if (done > width) done = width;
        let todo = width - done;

        let doneWidth = done + "px";
        let todoWidth = todo + "px";

        let txtExt = this.props.txt ? this.props.txt : '%';

        return (
            <div className="progbar">
                <span className={"progress status " + this.props.status} style={{
                    position: 'absolute',
                    zIndex: 0,
                    margin: 0,
                    backgroundColor: '#ffffff',
                    borderRadius: '1px',
                    width: doneWidth
                }}></span>

                <span className={"progress status " + this.props.status} style={{
                    position: 'absolute',
                    margin: 0,
                    left: doneWidth,
                    backgroundColor: '#b0b0b0',
                    borderRadius: '1px',
                    width: todoWidth
                }}>&nbsp;</span>

                <span style={{
                    position: 'absolute',
                    margin: 0,
                    //left: doneWidth,
                    color: '#222',
                    paddingLeft: '12px'
                }}>{done} {txtExt}</span>
            </div>
        );
    }
}


export default ProgressBar;
